import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { apiClient } from "src/services/config/apiClient";
import { API } from "src/services/config/apiConfig";
import { ConnectionEntity } from "src/types/apps";

export async function getLinkUpdateConnectionRequest(updateToken: string, authToken: string) {
	return await apiClient
		.get(API.QUERY.LINK.CONNECTIONS(updateToken), {
			headers: {
				Authorization: `Bearer ${authToken}`
			}
		})
		.then((res) => res.data);
}

export function useGetUpdateConnectionEntity(updateToken: string, authToken: string) {
	return useQuery<ConnectionEntity, AxiosError>({
		queryKey: ["link", "connection", updateToken],
		queryFn: () => getLinkUpdateConnectionRequest(updateToken, authToken),
		enabled: !!authToken && !!updateToken
	});
}
